const firebaseConfig = {
    apiKey: "AIzaSyDV0w-nKXOPkBeH9-nFlfu1NqPVkq5gUU0",
    authDomain: "health-care-1b160.firebaseapp.com",
    projectId: "health-care-1b160",
    storageBucket: "health-care-1b160.appspot.com",
    messagingSenderId: "1003477481029",
    appId: "1:1003477481029:web:d78213fda5f6f74a25152c"
  };

export default firebaseConfig;  